// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".padding-top-bottom-10[data-v-c143468a] {\n  padding: 10px 0;\n}\n.font-size-14[data-v-c143468a] {\n  font-size: 14px;\n}\n.color-red[data-v-c143468a] {\n  color: #f00;\n}\n.font-weight[data-v-c143468a] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
